<!--理论/考试 做题页面-->
<template>
  <div class="theory-layer">
    <div class="top-wrap">
      <div class="title-inner">{{ examInfo.examName }}</div>
      <div class="attach-inner">
        <span>分值：{{ examInfo.totalScore || 0 }}</span>
        <span>及格：{{ examInfo.passingScore || 0 }}</span>
      </div>
      <div class="score-inner" v-if="control.isOpenAnalysis">
        <span>{{ examInfo.score }}</span>
        <p>得分</p>
      </div>
    </div>

    <div class="bottom-wrap">
      <!-- 右侧题板 -->
      <div class="theory-left">
        <div class="user_block-target">
          <!-- <div class="userPhoto">
            <img src="~@imgs/userPhoto.png">
          </div>
          <div class="userName">
            <b>{{ $store.userInfo.userName }}</b>
            <span>{{ $store.userInfo.userNo }}</span>
          </div> -->
          <!-- 倒计时 -->
          <div class="timer-inner" v-show="examInfo.examType === '1'">{{ control.timeStr }}</div>
        </div>

        <!-- 做题标记 -->
        <div class="tagTip-inner">
          <!-- <h2>共 {{ testData.length }} 题</h2> -->
          <h2>答题</h2>
          <div>
            <span class="tag tag1"><i class="mark-inner ok"></i>已做</span>
            <span class="tag tag2"><i class="mark-inner"></i>未做</span>
            <span class="tag tag3"><i class="mark-inner success"></i>正确</span>
            <span class="tag tag4"><i class="mark-inner error"></i>错误</span>
          </div>
        </div>

        <!-- 题卡 -->
        <div class="QuestionCard">
          <div class="questionView" v-for="(typeArr, key) in questionTypes" :key="key">
            <h3>{{ questionEnum[key].label }}</h3>
            <ul>
              <li class="item mark-inner" v-for="(item, index) in typeArr" :key="index" :class="{
                'active': item.index == control.activeIndex,
                'ok': testData[item.index].is_Use == 1,
                'success': control.isOpenAnalysis && testData[item.index].is_True === 1,
                'error': control.isOpenAnalysis && testData[item.index].is_True === 0,
              }" @click="handleProblemChange(item.index)">
                {{ item.index + 1 }}
              </li>
            </ul>
          </div>
        </div>

        <div class="btn-wrap">
          <!-- 返回按钮 -->
          <div class="backBtn" @click="Back()">退出</div>
          <!-- 提交按钮 -->
          <div class="submitBtn" @click="submitTest">提交</div>
        </div>
      </div>

      <!-- 题目 -->
      <div class="theory-right">
        <div class="questionContent" v-if="activeProblemData && activeProblemData.data">
          <!-- 题目内容 -->
          <div class="scroll-view">
            <!-- 题目标题 -->
            <div class="questionTitle">
              <div class="indexs">{{ control.activeIndex + 1 }}、</div>
              <div class="questionText">
                <span v-html="activeProblemData.data.QB_Description"></span>
              </div>
              <div class="score-inner">{{ activeProblemData.data.EP_Score }}分</div>
            </div>

            <!-- 有附加资源 -->
            <div class="medium" v-if="activeProblemData.data.resourceURL">
              <!-- 视频 -->
              <video v-if="activeProblemData.data.sourcesType == 'mp4'" width="320" height="240" controls>
                <source :src="activeProblemData.data.resourceURL" type="video/mp4">
                您的浏览器不支持该视频格式。
              </video>
              <!-- 图片 -->
              <img v-else-if="activeProblemData.data.sourcesType == 'jpg' ||
                activeProblemData.data.sourcesType == 'png' ||
                activeProblemData.data.sourcesType == 'jpeg' ||
                activeProblemData.data.sourcesType == 'gif'" :src="activeProblemData.data.resourceURL">
              <!-- 音频 -->
              <audio v-else-if="activeProblemData.data.sourcesType == 'mp3'" controls>
                <source :src="activeProblemData.data.resourceURL" type="audio/mpeg">
                您的浏览器不支持该音频格式。
              </audio>
            </div>

            <!-- 题目作答区 -->
            <div class="questionOperation">
              <!-- 单选 -->
              <el-radio-group v-if="activeProblemData.type == 1 || activeProblemData.type == 9 || activeProblemData.type == 11"
                              v-model="activeProblemData.submitValue">
                <div v-for="(item, index) in optionTags" :key="index">
                  <el-radio class="option_inner" :label="item.label" v-if="activeProblemData.data[item.key]">
                    <span class="tag">{{ item.label }}</span>
                    <span>{{ activeProblemData.data[item.key] }}</span>
                    <img class="checkboxImg" :src="$store.projectData.FileUrl + activeProblemData.data['Option' + item]"
                         v-if="activeProblemData.type == 9 && activeProblemData.data['Option' + item]">
                  </el-radio>
                </div>
              </el-radio-group>

              <!-- 多选 -->
              <el-checkbox-group v-else-if="activeProblemData.type == 2 || activeProblemData.type == 10 || activeProblemData.type == 12"
                                 v-model="activeProblemData.submitValue">
                <div v-for="(item, index) in optionTags" :key="index">
                  <el-checkbox class="option_inner" :label="item.label" v-if="activeProblemData.data[item.key]">
                    <span class="tag">{{ item.label }}</span>
                    <span>{{ activeProblemData.data[item.key] }}</span>
                    <img class="checkboxImg" :src="$store.projectData.FileUrl + activeProblemData.data['Option' + item]"
                         v-if="activeProblemData.type == 10 && activeProblemData.data['Option' + item]">
                  </el-checkbox>
                </div>
              </el-checkbox-group>

              <!-- 判断 -->
              <el-radio-group v-else-if="activeProblemData.type == 3" v-model="activeProblemData.submitValue">
                <el-radio class="option_inner" label="对"><span class="tag">对</span></el-radio>
                <el-radio class="option_inner" label="错"><span class="tag">错</span></el-radio>
              </el-radio-group>

              <!-- 简答题 -->
              <div v-else-if="activeProblemData.type == 4 || activeProblemData.type == 5">
                <el-input type="textarea" v-model="activeProblemData.submitValue" :rows="5" placeholder="请输入内容"
                          maxlength="500" resize="none"></el-input>
              </div>
            </div>

            <!-- 答案解析 -->
            <div class="answerWarp" v-if="control.isOpenAnalysis && analysisData[activeProblemData.qbid]">
              <div>
                <p>考生答案为：</p>
                <span v-html="analysisData[activeProblemData.qbid].eD_Content"></span>
              </div>
              <div>
                <p>系统答案为：</p>
                <span v-html="analysisData[activeProblemData.qbid].qB_Answer"></span>
              </div>
              <div>
                <p>答案解析：</p>
                <span v-html="analysisData[activeProblemData.qbid].qB_Custom3"></span>
              </div>
            </div>

            <!-- 控制按钮 -->
            <div class="questionControlWarp">
              <div class="btn_inner btn_inner-pre" :class="{ disabled: control.activeIndex <= 0 }"
                   @click="handleProblemChange(control.activeIndex - 1)">
                上一题
              </div>
              <div class="btn_inner btn_inner-next" :class="{ disabled: !testData[control.activeIndex + 1] }"
                   @click="handleProblemChange(control.activeIndex + 1)">
                下一题
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'theory',
  components: {},
  props: {},
  data () {
    return {
      // 必要参数
      paramData: {
        e_id: 0,
        p_id: 0
      },
      // （动态）考试信息
      examInfo: {},
      // （动态）试卷内容
      testData: {},
      // （动态）开放的题型
      questionTypes: {},
      // （静态）设置项
      control: {
        caseTimer: null, // 定时器
        timeStr: '00:00:00', // 显示时间
        isOpenAnalysis: false, // 是否在查看解析
        activeIndex: 0 // 所选题下标
      },
      // （静态）题目类型
      questionEnum: {
        1: { label: '单选题', value: 1, key: 'dxtList' },
        2: { label: '多选题', value: 2, key: 'aDxtList' },
        3: { label: '判断题', value: 3, key: 'pdtList' },
        4: { label: '填空题', value: 4, key: '' },
        5: { label: '简答题', value: 5, key: '' },
        9: { label: '图片单选题', value: 9, key: '' },
        10: { label: '图片多选题', value: 10, key: '' },
        11: { label: '动画单选题', value: 11, key: '' },
        12: { label: '动画多选题', value: 12, key: '' }
      },
      // （静态）选项标签，key：数据索引，label：显示选项
      optionTags: [
        { key: 'QB_A', label: 'A' },
        { key: 'QB_B', label: 'B' },
        { key: 'QB_C', label: 'C' },
        { key: 'QB_D', label: 'D' },
        { key: 'QB_E', label: 'E' },
        { key: 'QB_F', label: 'F' }
      ],
      // 答案解析数据
      analysisData: {},
      // 是否已经提交
      isSubmit: false
    }
  },
  computed: {
    // 被选中题
    activeProblemData () {
      const data = this.testData
      const idx = this.control.activeIndex
      if (this.control.isOpenAnalysis && data[idx] && this.analysisData[data[idx].qbid]) {
        // 答案解析
        return {
          ...data[idx],
          submitValue: this.analysisData[data[idx].qbid].submitValue
        }
      } else {
        return data[idx]
      }
    }
  },
  watch: {},
  created () {
    this.paramData.pid = this.$route.query.pid
    this.paramData.eid = this.$route.query.eid

    if (this.paramData.pid && this.paramData.eid) {
      this.getExamInfo()
    } else {
      this.$alert('没有找到考核信息，请重新进入').then(() => {
        this.$router.back()
      })
    }
    //需注意：
    // 1.进入做题页需先判断是练习还是考核模式；
    // 2.练习模式没有单题提交，学生做过的题，未点提交按钮，记录不会被保存；
    // 3.考核模式学生有单题提交保存，再次进来有记录回显；
    // 4.倒计时结束自动提交;
    // 5.只有做题历史尽进入才有解析查看
  },
  mounted () { },
  methods: {
    //获取题目信息
    getExamInfo () { },
    //提交
    submitTest () { }
  }
}
</script>

<style scoped lang="less">
@import url("./index.less");

.theory-layer {
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}
</style>
